// shared.service.ts
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SharedService {

    private storedRole = sessionStorage.getItem('rolesPermission') || '{}';
    private userRoleSubject = new BehaviorSubject<string>(this.storedRole);
    userRole$ = this.userRoleSubject.asObservable();


    updateUserRole(role: any) {
        const roleString = typeof role === 'string' ? role : JSON.stringify(role);
        sessionStorage.setItem('rolesPermission', roleString); // optional
        this.userRoleSubject.next(JSON.parse(roleString || '{}'));
        //this.userRoleSubject.next(roleString);

    }


    private divVisibility = new BehaviorSubject<boolean>(false);
    divVisibility$ = this.divVisibility.asObservable();

    setDivVisibility(isVisible: boolean): void {
        this.divVisibility.next(isVisible);
    }


}
